export const odst = [
  { value: "ODS 1 Fin de la Pobreza", label: "ODS 1 Fin de la Pobreza" },
  { value: "ODS 2 Hambre Cero", label: "ODS 2 Hambre Cero" },
  { value: "ODS 3 Salud y Bienestar", label: "ODS 3 Salud y Bienestar" },
  { value: "ODS 4 Educación de Calidad", label: "DS 4 Educación de Calidad" },
  { value: "ODS 5 Igualdad de Género", label: "ODS 5 Igualdad de Género" },
  {
    value: "ODS 6 Agua Limpia y Saneamiento",
    label: "ODS 6 Agua Limpia y Saneamiento"
  },
  {
    value: "ODS 7 Energía Asequible y No Contaminante",
    label: "ODS 7 Energía Asequible y No Contaminante"
  },
  {
    value: "ODS 8 Trabajo Decente y Crecimiento Económico",
    label: "ODS 8 Trabajo Decente y Crecimiento Económico"
  },
  {
    value: "ODS 9 Industria, Innovación e Infraestructura",
    label: "ODS 9 Industria, Innovación e Infraestructura"
  },
  {
    value: "ODS 10 Reducción de las Desigualdades",
    label: "ODS 10 Reducción de las Desigualdades"
  },
  {
    value: "ODS 11 Ciudades y Comunidades Sostenibles",
    label: "ODS 11 Ciudades y Comunidades Sostenibles"
  },
  {
    value: "ODS 12 Producción y Consumo Responsable",
    label: "ODS 12 Producción y Consumo Responsable"
  },
  { value: "ODS 13 Acción Por el Clima", label: "ODS 13 Acción Por el Clima" },
  { value: "ODS 14 Vida Submarina", label: "ODS 14 Vida Submarina" },
  {
    value: "ODS 15 Vida de Ecosistemas Terrestres",
    label: "ODS 15 Vida de Ecosistemas Terrestres"
  },
  {
    value: "ODS 16 Paz, Justicia e Instituciones Sólidas",
    label: "ODS 16 Paz, Justicia e Instituciones Sólidas"
  },
  {
    value: "ODS 17 Alianzas para Lograr los Objetivos",
    label: "ODS 17 Alianzas para Lograr los Objetivos"
  }
];
